import React from 'react'
import { Box } from '@mui/material'
import { ImageVerificationPreview } from '../../image_verification/ImageVerificationPreview'
import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { altTextTreeAtom } from './atoms'

// Maintenance - This page gives us an idea if the tree is ready for
// alt text updates. We might need to convert data sources to S3 links
// or retrieve external links and put them in our own S3
export function Maintenance() {
  const { tree, resetTree } = useAtomValue(altTextTreeAtom)

  if (!tree || !resetTree) return null

  return (
    <Box>
      <ImageVerificationPreview tree={tree} didUpdateTree={resetTree} />
    </Box>
  )
}
